var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { HashLink } from 'react-router-hash-link';
import { Accordion, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronUp, faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { ContentBox, ContentBoxBody, ContentBoxHead, getCMSObject, TeleScript, ErrorMessage, NumberSelector } from '../../../index';
import './allocatable-entries.scss';
library.add(faChevronDown, faChevronUp);
var AllocatableEntriesForm = function (_a) {
    var sweepId = _a.sweepId, promotionName = _a.promotionName, numEntries = _a.numEntries, entryId = _a.entryId, actions = _a.actions, sweep = _a.sweep;
    var _b = useState('tbd'), defaultPrizeName = _b[0], setDefaultPrizeName = _b[1];
    var _c = useState([]), drawingGroups = _c[0], setDrawingGroups = _c[1];
    var _d = useState(new Map()), currentAllocatedEntries = _d[0], setCurrentAllocatedEntries = _d[1];
    var _e = useState(numEntries), unallocatedEntries = _e[0], setUnallocatedEntries = _e[1];
    var _f = useState(false), allowSubmission = _f[0], setAllowSubmission = _f[1];
    var _g = useState(''), error = _g[0], setError = _g[1];
    var _h = useState([]), sweepDetails = _h[0], setSweepDetails = _h[1];
    var _j = useState([]), allocationResults = _j[0], setAllocationResults = _j[1];
    var myActivityTelescript = getCMSObject('data.components.teleScripts.myActivity.jsonBlock');
    function fetchSweeps() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, actions.sweepActions.getActiveSweeps()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    //***********************************************************************************
    // Gather up all the entries and pack them into the payload to allocate them
    //
    //  api:  /api/sweepstakes/$sweepstake_id/entries/allocate
    //  @param - $sweepstake_id - the allocatable sweeps
    //  * @param $entry_id      - the player's allocatable entry
    //  * @param array $allocations - array of tuples (drawing_group_id, entry_count)
    //
    var submitEntries = function () { return __awaiter(void 0, void 0, void 0, function () {
        var allocationsArray;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, actions.sweepActions.clearAllocatableDetails(sweepId)];
                case 1:
                    _b.sent();
                    allocationsArray = [];
                    currentAllocatedEntries.forEach(function (entries, id) {
                        allocationsArray.push({ drawing_group_id: id, entry_count: entries });
                    });
                    return [4 /*yield*/, actions.sweepActions.allocateEntries({
                            sweepstake_id: sweepId,
                            entry_id: entryId,
                            allocation: allocationsArray,
                        })];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, actions.sweepActions.getActiveSweeps()];
                case 3:
                    _b.sent();
                    return [4 /*yield*/, actions.sweepActions.getPlayerAllocatableEntries()];
                case 4:
                    _b.sent();
                    return [4 /*yield*/, ((_a = actions.winnerActions) === null || _a === void 0 ? void 0 : _a.getCurrentDrawings())];
                case 5:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); }; // end submitEntries
    //***********************************************************************************
    // On load get the sweeps details.
    //
    useEffect(function () {
        setUnallocatedEntries(numEntries);
        // NOTE:   To prevent too many API calls, the parent object should call getSweeps first to
        // populate the store.    We include this here just in case the sweeps array is empty and we don't
        // have the needed data to populate the form.
        if (sweep && !sweep.active.length) {
            fetchSweeps();
        }
        return function () {
            setSweepDetails([]);
            setError('');
            setCurrentAllocatedEntries([]);
            setDefaultPrizeName([]);
            setDrawingGroups([]);
        };
    }, []);
    useEffect(function () {
        // filter list of sweeps down. . .
        var thisSweep = sweep &&
            sweep.active.filter(function (sweepstake) {
                if (sweepstake.id == sweepId) {
                    return sweepstake;
                }
            });
        if (thisSweep) {
            setSweepDetails(thisSweep[0]);
        }
        // See if this sweep was allocated and what the result was
        if (sweep && sweep.allocatedDetails.length >= 1) {
            var sweepAllocatedResults = sweep.allocatedDetails.filter(function (allocatedResult) {
                if (allocatedResult.sweepId === sweepId && allocatedResult.entryId === entryId) {
                    return allocatedResult;
                }
            });
            if (sweepAllocatedResults && sweepAllocatedResults.error && sweepAllocatedResults.data && sweepAllocatedResults.data.code) {
                setError(sweepAllocatedResults.data.code);
            }
            setAllocationResults(sweepAllocatedResults);
        }
    }, [sweep]);
    useEffect(function () {
        var _a, _b, _c;
        if (sweepDetails && sweepDetails.drawing_groups) {
            var entries_1 = new Map();
            var defaultPrize = sweepDetails.drawing_groups.filter(function (drawGroup) {
                entries_1.set(drawGroup.id, 0);
                if (drawGroup.default_allocation)
                    return drawGroup;
            });
            setCurrentAllocatedEntries(new Map(entries_1));
            setDefaultPrizeName((_b = (_a = defaultPrize[0]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '');
            setDrawingGroups((_c = sweepDetails.drawing_groups) !== null && _c !== void 0 ? _c : '');
        }
    }, [sweepDetails]);
    //***********************************************************************************
    // Render of each Drawing group and its pickers for allocatable entries.
    //
    //
    var DrawingGroupDisplay = function (_a) {
        var _b, _c, _d, _e, _f, _g, _h;
        var drawing = _a.drawing;
        var _j = useState(false), detailsOpen = _j[0], setDetailsOpen = _j[1];
        var numWinners = 0;
        var currentValue = currentAllocatedEntries.get(drawing.id);
        drawing.prizes.forEach(function (prize) {
            numWinners += prize.quantity;
        });
        var prizeDetails = drawing.extra && drawing.extra.prize_details ? drawing.extra.prize_details : '';
        // Allows toggling of the Prize Details accordion
        var togglePrizeDetails = function () {
            setDetailsOpen(!detailsOpen);
        }; // end togglePrizeDetails
        // On a change of the number selectors,  update the allocated entries map
        var manageEntries = function (value) {
            if (value != 'undefined') {
                var tempEntries = currentAllocatedEntries;
                tempEntries.set(drawing.id, value);
                setCurrentAllocatedEntries(function (currentAllocatedEntries) { return new Map(__spreadArray(__spreadArray([], currentAllocatedEntries, true), [[drawing.id, value]], false)); });
            }
        }; // end manageEntries
        // calculate the unallocated entries left check to see if we can submit the form
        useEffect(function () {
            var totalCurrentlyAllocated = 0;
            currentAllocatedEntries.forEach(function (value) {
                totalCurrentlyAllocated += value;
            });
            var unallocated = numEntries - totalCurrentlyAllocated;
            unallocated === 0 ? setAllowSubmission(false) : setAllowSubmission(true);
            setUnallocatedEntries(unallocated);
        }, [currentAllocatedEntries]);
        return (_jsxs("div", { className: 'container drawing-group', children: [_jsxs("div", { className: 'row', children: [_jsx("div", { className: 'col', children: ((_b = drawing.extra) === null || _b === void 0 ? void 0 : _b.image) && _jsx("img", { src: (_d = (_c = drawing.extra) === null || _c === void 0 ? void 0 : _c.image) !== null && _d !== void 0 ? _d : '', alt: (_e = drawing.name) !== null && _e !== void 0 ? _e : '', className: 'img-fluid' }) }), _jsxs("div", { className: 'col', children: [_jsx("h4", { className: 'drawing-group-drawing-name', children: (_f = drawing.name) !== null && _f !== void 0 ? _f : '' }), _jsx("p", { dangerouslySetInnerHTML: { __html: (_h = (_g = drawing.extra) === null || _g === void 0 ? void 0 : _g.description) !== null && _h !== void 0 ? _h : '' } }), _jsx("p", { children: _jsxs(TeleScript, { line: myActivityTelescript === null || myActivityTelescript === void 0 ? void 0 : myActivityTelescript.drawingGroupWinners, replace: {
                                            '%WINNER_VERBIAGE%': numWinners > 1 ? 'Winners' : 'Winner',
                                            '%NUMBER_WINNERS%': numWinners,
                                        }, children: [numWinners, " ", numWinners > 1 ? 'Winners' : 'Winner', " / drawing."] }) })] })] }), _jsxs("div", { className: 'row', children: [_jsx("div", { className: 'col-sm-8', children: _jsx(Accordion, { className: 'prize-details', children: _jsxs(Card, { children: [_jsxs(Accordion.Toggle, { as: Card.Header, eventKey: '0', onClick: function () { return togglePrizeDetails(); }, className: 'prize-details-section', children: [_jsx(TeleScript, { line: myActivityTelescript === null || myActivityTelescript === void 0 ? void 0 : myActivityTelescript.AccordionTitlePrizeDetails, children: "Prize Details" }), detailsOpen ? _jsx(FontAwesomeIcon, { icon: 'fa-solid fa-chevron-up' }) : _jsx(FontAwesomeIcon, { icon: 'fa-solid fa-chevron-down' })] }), _jsx(Accordion.Collapse, { eventKey: '0', children: _jsx(Card.Body, { children: _jsx("p", { dangerouslySetInnerHTML: { __html: prizeDetails } }) }) })] }) }) }), _jsx("div", { className: 'col-sm-4', children: _jsx(NumberSelector, { value: currentValue, max: unallocatedEntries + currentValue, label: 'Number of entries', parentCallback: manageEntries }) })] })] }));
    }; // end DrawingGroupDisplay
    return (_jsx(_Fragment, { children: error ? (_jsx("div", { className: 'allocatable-entries-form', children: _jsx(ErrorMessage, { code: error, collection: 'data.messages.ticketErrorMessages.jsonBlock' }) })) : (_jsx("div", { className: 'allocatable-entries-form', children: allocationResults.length && allocationResults[0].submitted ? (_jsx("div", { className: 'entries-submitted-success', children: _jsx(TeleScript, { line: myActivityTelescript === null || myActivityTelescript === void 0 ? void 0 : myActivityTelescript.entriesSuccessMessage, children: "Success: Your entries have been submitted! Your entries can be reviewed in My Drawing Entries and the Second Chance Promotion page." }) })) : (_jsxs(ContentBox, { variant: 'theme-primary', children: [_jsx(ContentBoxHead, { children: _jsx(TeleScript, { line: myActivityTelescript === null || myActivityTelescript === void 0 ? void 0 : myActivityTelescript.allocatableEntriesPopupTitle, children: "My Unassigned Entries" }) }), _jsxs(ContentBoxBody, { children: [_jsx("p", { className: 'text-center', children: _jsxs(TeleScript, { line: myActivityTelescript === null || myActivityTelescript === void 0 ? void 0 : myActivityTelescript.allocatableEntriesPopupEntriesMessage, replace: {
                                        '%NUM_ENTRIES%': numEntries,
                                        '%Entries%': numEntries > 1 ? 'entries' : 'entry',
                                        '%PROMOTION_NAME%': promotionName,
                                    }, children: ["You have earned ", _jsx("strong", { children: numEntries }), " ", numEntries > 1 ? 'entries' : 'entry', " into the ", promotionName, " drawing of your choice. Use the \u201C-\u201D and \u201C+\u201D buttons below to choose which drawing to enter."] }) }), window.location.pathname !== '/my-activity' ? (_jsxs("p", { className: 'later-time-message', children: ["You may also assign your entries at a later time, prior to the draw date by viewing your", _jsx(HashLink, { to: '/my-activity#allocatable-entries', children: "unassigned entries table in My Activity" }), "."] })) : null, _jsx("p", { className: 'text-center', children: _jsxs(TeleScript, { line: myActivityTelescript === null || myActivityTelescript === void 0 ? void 0 : myActivityTelescript.allocatableEntriesPopupEntriesMessage, replace: {
                                        '%DEFAULT_PRIZE_NAME%': defaultPrizeName,
                                    }, children: ["If entries remain unassigned by the time of the drawing, they are automatically entered into ", defaultPrizeName, "."] }) }), _jsxs("h3", { className: 'entries-to-allocate', children: [unallocatedEntries, " ", unallocatedEntries > 1 ? 'Entries' : 'Entry', " to Assign"] }), drawingGroups.map(function (drawingGroup, index) {
                                return _jsx(DrawingGroupDisplay, { drawing: drawingGroup }, index);
                            }), _jsx("div", { className: 'text-center', children: _jsx("button", { className: 'submit-allocatable', disabled: allowSubmission, onClick: submitEntries, children: _jsx(TeleScript, { line: myActivityTelescript === null || myActivityTelescript === void 0 ? void 0 : myActivityTelescript.submitAllocatableBtnText, children: "Submit Entries " }) }) })] })] })) })) }));
};
export default AllocatableEntriesForm;
